import { getSavedTemplates } from "../selectors/templates";

const dossierItemSchema = function (state, props, dossierItemType) {
  const templates = getSavedTemplates("note")(state)

  const uiSchema = {
    "ui:readonly": props.readonly,
    "title" : {
      "ui:visible": dossierItemType === 'note',
      "ui:group": "line",
      "ui:options": {
        "ui:width": 2,
        "label": false
      }
    },
    "text": {
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget":"RichTextWidget",
      "ui:options": {
        "label": false,
        "useTemplates": {templates: templates}
      },
    },
    "dossierItemType": {
      "ui:widget": "hidden"
    },
    "consultationId": {
      "ui:widget": "hidden"
    },
    "dossierId": {
      "ui:widget": "hidden"
    },
    "attachment": {
      "ui:widget": "hidden"
    },
    "attachmentTitle": {
      "ui:widget": "hidden"
    },
    "time" : {
      "ui:visible": dossierItemType === 'note',
      "ui:group": "line",
      "ui:options": {
        "ui:width": 2,
        "label": false
      }
    },
  }


  return uiSchema
}

export default dossierItemSchema;
